import HrnDeleteConfirm from "./HrnDeleteConfirm";

export default HrnDeleteConfirm;